// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/soft-field-takeoff.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/soft-field-takeoff/soft-field-takeoff.js';

mount([g0]);
